import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  EventEmitter,
  Input,
  Output,
  ChangeDetectorRef,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  ClientSubscriptionService,
  ToastMessageService,
  SubscriptionService,
  TenantService,
} from '@fitness-force/api';
import { BillingAddOnComponent } from '@fitness-force/billing';
import { NotificationChannels, PlanCategory, SubscriptionStatus, TrackMode } from '@fitness-force/enum';
import { AppErrors, ErrorMsgComponent } from '@fitness-force/errors';
import {
  InvoiceOccurance,
  PlanAddons,
  SubscriptionById,
  voidSubscriptionRequest,
} from '@fitness-force/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, NotFoundError } from 'rxjs';
import { SubscriptionCancelComponent } from '../client-profile/subscription-tab/subscription-cancel/subscription-cancel.component';
import { SubscriptionFreeDiscountComponent } from '../client-profile/subscription-tab/subscription-free-discount/subscription-free-discount.component';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';

import { ButtonModule } from 'primeng/button';

import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import Statsig from 'statsig-js';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { RouteStateService } from '../../router-guard/route-state-service.service';
import { PopoverModule } from 'primeng/popover';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'subscription-action-list',
  templateUrl: './subscription-action-list.component.html',
  styleUrls: ['./subscription-action-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [    
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SubscriptionFreeDiscountComponent,
    BillingAddOnComponent,
    SubscriptionCancelComponent,
    DialogModule,
    MessageModule,
    ButtonModule,
    RippleModule,
    StyleClassModule,
    ConfirmPopupModule,
    ErrorMsgComponent,
    PopoverModule,
    TranslateModule
  ],
})
export class SubscriptionActionListComponent implements OnInit {
  @Input('clientId')  clientId: number = 0;  
  @Input('tenantId') tenantId: number = 0;
  @Input('subscriptionId') subscriptionId: number = 0;
  @Input('signupId') signupId: number = 0;
  @Input('subscription') subscriptionDetails: SubscriptionById;
  @Input('showFreeDiscount') showFreeDiscountAction: boolean = false;
  @Input('paymentTimelineData') paymentTimelineData = new BehaviorSubject<InvoiceOccurance[]>([]);
  @Input('trackMode') trackMode: TrackMode = TrackMode.StaffWebApp ;
  @Input('class') class: string = 'absolute right-0 top-0 mt-2 mr-2 flex align-items-center justify-content-end';
  @Output('closeAddonEvent') closeAddonEvent: EventEmitter<{ event: any, subscription: any }> = new EventEmitter();
  @Output('emitEvents') emitEvents: EventEmitter<any> = new EventEmitter();

  btnLoading: boolean = false;
  reloadData: boolean = false;
  showSkeleton$ = new BehaviorSubject<boolean>(true);
  getAccessTenantList$: any;
  allTenants: any;
  voidSubscriptionForm: UntypedFormGroup = new UntypedFormGroup({});
  ActivateMebershipForm: UntypedFormGroup = new UntypedFormGroup({});
  VoidSubscriptionSignupForm: UntypedFormGroup = new UntypedFormGroup({});
  signUpDetails: any;
  showVoidSubscriptionModal: boolean = false;
  upgradedSubscription: boolean = false;
  btnLoading$ = new BehaviorSubject<boolean>(false);

  ActivateMembershipPopup: boolean = false;
  activateMembership: boolean = false;

  showFreeDiscountApply = new BehaviorSubject(false);
  clientDetails: any;
  addDiscountedPeriod: boolean = false;
  showAddonSidebar: boolean = false;
  planId: number = 0;
  selectedAddons = new BehaviorSubject<PlanAddons[]>([]);
  showCancelSubscription: boolean = false;
  clientSubscriptionData = new BehaviorSubject<any>({});

  showTransfer = new BehaviorSubject(false);
  voidSignUpBtnLoading: boolean = false;
  voidSignUpPopup: boolean = false;
  showAddonBilling = new BehaviorSubject(false);

  sendLinkCollectDues: boolean = false;
  emailSelected: boolean = false;
  smsSelected: boolean = false;
  whatsappSelected: boolean = false;
  isPresaleTenant: boolean = false;

  constructor(
    private toastMessageService: ToastMessageService,
    public changeDetectorRef: ChangeDetectorRef,
    private translate: TranslateService,
    private subscriptionService: SubscriptionService,
    private fb: UntypedFormBuilder,
    private confirmationService: ConfirmationService,
    private clientSubscriptionService: ClientSubscriptionService,
    private router: Router,
    private tenantService:TenantService,
    public routeStateService: RouteStateService
  ) {
    this.isPresaleTenant = this.tenantService.IsPresaleTenant();
   }

  ngOnInit(): void {
    this.clientSubscriptionData.next(this.subscriptionDetails);
    if (Statsig.checkGate('show_add_discount_on_billing_cycle')) {
      this.showFreeDiscountApply.next(true);
    } else this.showFreeDiscountApply.next(false);

    if (Statsig.checkGate('show_transfer')) {
      this.showTransfer.next(true);
    }

    if (Statsig.checkGate("show_addons_billing")) {
      this.showAddonBilling.next(true);
    } else {
      this.showAddonBilling.next(false);
    }

    this.voidSubscriptionForm = this.fb.group({
      void_reason: ['', [Validators.required]],
    });

    this.ActivateMebershipForm = this.fb.group({
      change_reason: ['', [Validators.required]],
    });

    this.VoidSubscriptionSignupForm = this.fb.group({
      void_reasons: ['', [Validators.required]],
    });
    this.changeDetectorRef.detectChanges();
  }

  showVoidSubscription(subscription: any) {
    this.subscriptionDetails = subscription;
    this.showVoidSubscriptionModal = true;
    if (
      subscription.upgrade_from_clt_subs_id &&
      subscription.upgrade_from_clt_subs_id > 0
    )
      this.upgradedSubscription = true;
    else this.upgradedSubscription = false;
  }

  voidSubscription(form: UntypedFormGroup) {
    this.btnLoading$.next(true);
    if (form.valid) {
      let voidRequest: voidSubscriptionRequest = {} as voidSubscriptionRequest;
      voidRequest.void_reason = form.value.void_reason;
      var service: any;
      if (this.upgradedSubscription) {
        service = this.subscriptionService.VoidUpgradeSubscription(
          this.subscriptionDetails.tenant_id,
          this.clientId,
          this.subscriptionDetails.id,
          voidRequest
        );
      } else {
        service = this.subscriptionService.VoidSubscription(
          this.subscriptionDetails.tenant_id,
          this.clientId,
          this.subscriptionDetails.id,
          voidRequest
        );
      }
      service.subscribe({
        next: (data: any) => {
          this.translate
            .get('SUBSCRIPTIONS.MSG.SUBSCRIPTION_VOID_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.voidSubscriptionForm.reset();
          this.btnLoading$.next(false);
          this.showVoidSubscriptionModal = false;
          this.emitEvents.emit(true);
          //this.componentInit();
        },
        error: (error: AppErrors) => {
          this.btnLoading$.next(false);
          this.toastMessageService.showError(error);
        },
      });
    } else {
      Object.keys(this.voidSubscriptionForm.controls).forEach((field) => {
        const control = this.voidSubscriptionForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      this.btnLoading$.next(false);
    }
  }

  showActiveMembershipBtn(status: string) {
    var subscrptionStatus = SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return subscrptionStatus == SubscriptionStatus.PendingForMandatoryAction;
  }

  ShowActivateMembership(subscription: any) {
    this.subscriptionDetails = subscription;
    this.activateMembership = true;
    this.ActivateMembershipPopup = true;
  }

  CanAddFreeDiscount(status: string) {
    var subscrptionStatus =
      SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return (
      subscrptionStatus == SubscriptionStatus.Active ||
      subscrptionStatus == SubscriptionStatus.Frozen ||
      subscrptionStatus == SubscriptionStatus.NotRenewing ||
      subscrptionStatus == SubscriptionStatus.Future
    );
  }

  IsSubscrptionVoidOrCancelled(status: string) {
    var subscrptionStatus = SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return (subscrptionStatus == SubscriptionStatus.Void || subscrptionStatus == SubscriptionStatus.Cancelled || subscrptionStatus == SubscriptionStatus.Upgraded);
  }

  IsSubscrptionManageLinkValid(status: string) {
    var subscrptionStatus = SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return (subscrptionStatus == SubscriptionStatus.Future || subscrptionStatus == SubscriptionStatus.Active
      || subscrptionStatus == SubscriptionStatus.Frozen
      || subscrptionStatus == SubscriptionStatus.SuspendedDueToNonPayment
      || subscrptionStatus == SubscriptionStatus.PendingForMandatoryAction
      || subscrptionStatus == SubscriptionStatus.PendingForPaymentConfirmation
    );
  }

  showFreeDiscount(ss: any) {
    this.clientDetails = {
      client_id: this.clientId,
      name: 'test',
      image: '',
    };
    this.addDiscountedPeriod = true;
    this.subscriptionId = ss.id;
  }

  closeFreeDiscountPopup(event: any) {
    this.addDiscountedPeriod = false;
    this.emitEvents.emit(event);
  }

  ShowMidCycleAddon() {
    this.planId = this.subscriptionDetails.plan_id;
    this.showAddonSidebar = true;
  }

  closeAddonSidebar(event: any) {
    this.showAddonSidebar = false;
    this.closeAddonEvent.emit({ event: event, subscription: this.subscriptionDetails });
  }

  isNotRenewingStatus(status: string) {
    var subscrptionStatus =
      SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return subscrptionStatus == SubscriptionStatus.NotRenewing;
  }

  ReActivateMembership(subscription: any) {
    this.subscriptionDetails = subscription;
    this.activateMembership = false;
    this.ActivateMembershipPopup = true;
  }

  VoidSignUp() {
    this.voidSignUpBtnLoading = true;
    this.signUpDetails = this.subscriptionDetails;
    this.voidSignUpPopup = true;
  }

  SubmitVoidSignup(event: Event) {
    if (this.VoidSubscriptionSignupForm.valid) {
      let translation: any;
      this.translate
        .get([
          'BILL_OWNER_CHANGE.CHANGE_INFO',
          'common.BUTTONS.BUTTON-TEXT-YES',
          'common.BUTTONS.BUTTON-TEXT-NO'
  ])
        .subscribe((translations) => {
          translation = translations;
        });
      this.confirmationService.confirm({
        target: event.target as EventTarget,
        key: 'activatemembership',
        message: 'Are you sure that you want to proceed?',
        icon: 'fa fa-exclamation-triangle',
        acceptLabel: translation['common.BUTTONS.BUTTON-TEXT-YES'],
        rejectLabel: translation['common.BUTTONS.BUTTON-TEXT-NO'],
        accept: () => {
          let changeRequest: any = {} as any;
          changeRequest.void_reasons = this.VoidSubscriptionSignupForm.value.void_reasons;
          this.subscriptionService.VoidSignUp(
            this.tenantId,
            this.clientId,
            this.signupId,
            changeRequest
          )
            .subscribe({
              next: (subscp: any) => {
                this.translate
                  .get('SUBSCRIPTIONS.MSG.SIGNUP_VOID_MSG')
                  .subscribe((translation) => {
                    this.toastMessageService.showSuccess(translation);
                  });
                this.voidSignUpBtnLoading = false;
                this.voidSignUpPopup = false;
                this.VoidSubscriptionSignupForm.reset();
                this.emitEvents.emit(true);
              },
              error: (error) => {
                this.voidSignUpBtnLoading = false;
                if (error.originalError.status == 200) {
                  this.translate
                    .get('SUBSCRIPTIONS.MSG.SIGNUP_VOID_MSG')
                    .subscribe((translation) => {
                      this.toastMessageService.showSuccess(translation);
                    });
                  this.voidSignUpPopup = false;
                } else {
                  this.handleError(error);
                  this.voidSignUpPopup = false;
                }
              },
            });
        },
        reject: () => {
          this.voidSignUpPopup = false;
          this.voidSignUpBtnLoading = false;
          this.VoidSubscriptionSignupForm.reset();
        },
      });
    } else {
      Object.keys(this.VoidSubscriptionSignupForm.controls).forEach((field) => {
        const control = this.VoidSubscriptionSignupForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }

  handleError(error: any) {
    if (error instanceof NotFoundError) {
      this.translate
        .get([
          'common.errors.SERVER_SIDE.ERROR_OCCURRED',
          'SUBSCRIPTIONS.MSG_NOT_FOUND'
  ])
        .subscribe((translations: any) => {
          this.toastMessageService.showErrorMessage(translations);
        });
    } else {
      this.translate
        .get([
          'common.errors.SERVER_SIDE.ERROR_OCCURRED',
          'common.errors.SERVER_SIDE.SOMETHING_WRONG'
  ])
        .subscribe((translations: any) => {
          this.toastMessageService.showErrorMessage(translations);
        });
    }
  }

  ShowToastErrors(error: any) {
    if (error.originalError.error && error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        this.toastMessageService.showErrorMessage(e.errorMessage);
      });
    } else {
      if (error.originalError.error.errorMessage) {
        this.toastMessageService.showErrorMessage(error.originalError.error.errorMessage);
      } else {
        this.translate
          .get([
            'common.errors.SERVER_SIDE.ERROR_OCCURRED',
            'common.errors.SERVER_SIDE.SOMETHING_WRONG'
  ])
          .subscribe((translations: any) => {
            this.toastMessageService.showErrorMessage(translations);
          });
      }
    }
  }

  getEventData(event: any) {
    if (event) this.reloadData = true;
  }

  ActivateConfirm(event: Event) {
    if (this.ActivateMebershipForm.valid) {
      let translation: any;
      this.translate
        .get([
          'BILL_OWNER_CHANGE.CHANGE_INFO',
          'common.BUTTONS.BUTTON-TEXT-YES',
          'common.BUTTONS.BUTTON-TEXT-NO'
  ])
        .subscribe((translations) => {
          translation = translations;
        });
      this.confirmationService.confirm({
        target: event.target as EventTarget,
        key: 'activatemembership',
        message: 'Are you sure that you want to proceed?',
        icon: 'fa fa-exclamation-triangle',
        acceptLabel: translation['common.BUTTONS.BUTTON-TEXT-YES'],
        rejectLabel: translation['common.BUTTONS.BUTTON-TEXT-NO'],
        accept: () => {
          let changeRequest: any = {} as any;
          changeRequest.change_reason =
            this.ActivateMebershipForm.value.change_reason;
          let service: any;
          if (this.activateMembership)
            service = this.clientSubscriptionService.ActivateMembership(
              this.subscriptionDetails.tenant_id,
              this.clientId,
              this.subscriptionDetails.id,
              changeRequest
            );
          else
            service = this.clientSubscriptionService.ReActivateMembership(
              this.subscriptionDetails.tenant_id,
              this.clientId,
              this.subscriptionDetails.id,
              changeRequest
            );
          service.subscribe({
            next: (data: any) => {
              this.translate
                .get('SUBSCRIPTIONS.MSG.SUBSCRIPTION_ACTIVE_MSG')
                .subscribe((translation) => {
                  this.toastMessageService.showSuccess(translation);
                });
              this.ActivateMebershipForm.reset();
              this.ActivateMembershipPopup = false;
              this.emitEvents.emit(true);
              //this.componentInit();
            },
            error: (error: AppErrors) => {
              this.toastMessageService.showError(error);
            },
          });
        },
        reject: () => {
          this.ActivateMembershipPopup = false;
        },
      });
    } else {
      Object.keys(this.ActivateMebershipForm.controls).forEach((field) => {
        const control = this.ActivateMebershipForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }

  isMinimumDateTimeValue(eta: Date): Boolean {
    return (
      new Date(eta).getTime() === new Date('0001-01-01T00:00:00').getTime()
    );
  }

  GoToCancel(subscription: any) {
    this.showCancelSubscription = true;
  }

  closeSubscriptionCancelEvent(event: { reloadData: boolean, subscription: any }) {
    this.showCancelSubscription = false;
    this.clientSubscriptionData.next(event.subscription);
    this.emitEvents.emit(event.reloadData);
  }

  goToUpgrade() {
    this.router.navigate(['/client-management/upgrade', this.clientId]);
    this.routeStateService.closeClientSidebar(true);
    this.routeStateService.setCloseOmniSearchSidebarAll(true);
  }

  goToTransfer() {
    this.router.navigate([
      '/client-management/client-transfer/create',
      this.clientId
  ]);
    this.routeStateService.closeClientSidebar(true);
    this.routeStateService.setCloseOmniSearchSidebarAll(true);
  }

  goToFreeze() {
    this.router.navigate(['/pos/freeze', this.clientId]);
    this.routeStateService.closeClientSidebar(true);
    this.routeStateService.setCloseOmniSearchSidebarAll(true);
  }

  get VoidReasonFormControl(): UntypedFormControl {
    return this.voidSubscriptionForm.controls.void_reason as UntypedFormControl;
  }

  get ChangeReasonActiveFormControl(): UntypedFormControl {
    return this.ActivateMebershipForm.controls.change_reason as UntypedFormControl;
  }

  get VoidSignupReasonFormControl(): UntypedFormControl {
    return this.VoidSubscriptionSignupForm.controls
      .void_reasons as UntypedFormControl;
  }

  get isRecurring(): boolean {
    return (
      this.subscriptionDetails &&
      this.subscriptionDetails.subscription_category &&
      (this.subscriptionDetails.subscription_category == PlanCategory.Contract ||
        this.subscriptionDetails.subscription_category.toString() == PlanCategory[PlanCategory.Contract] ||
        this.subscriptionDetails.subscription_category == PlanCategory.PayAsYouGo ||
        this.subscriptionDetails.subscription_category.toString() == PlanCategory[PlanCategory.PayAsYouGo])
    );
  }


  CanSendCollectionDuesLink(status: string) {
    var subscrptionStatus =
      SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return (
      subscrptionStatus == SubscriptionStatus.Future ||
      subscrptionStatus == SubscriptionStatus.Active ||
      subscrptionStatus == SubscriptionStatus.Frozen ||
      subscrptionStatus == SubscriptionStatus.SuspendedDueToNonPayment ||
      subscrptionStatus == SubscriptionStatus.PendingForMandatoryAction ||
      subscrptionStatus == SubscriptionStatus.PendingForPaymentConfirmation
    );
  }

  SendLinkCollectDuesClick() {
    this.sendLinkCollectDues = true;
  }


  funSendCollectDuesLink(event: Event) {
    let voidRequest: voidSubscriptionRequest = {} as voidSubscriptionRequest;
    var service: any;
    let selectedChannels: NotificationChannels[] = [];

    if (this.emailSelected) {
      selectedChannels.push(NotificationChannels.Email);
    }
    if (this.smsSelected) {
      selectedChannels.push(NotificationChannels.SMS);
    }
    if (this.whatsappSelected) {
      selectedChannels.push(NotificationChannels.WhatsApp);
    }

    if (selectedChannels.length == 0) {
      this.translate
        .get('SUBSCRIPTIONS.MSG.SUBSCRIPTION_CHANNEL_NOTSELECTED')
        .subscribe((translation) => {
          this.toastMessageService.showErrorMessage(translation);
        });
      return
    }

    service = this.subscriptionService.ClientSubscriptionSendManageLink(this.subscriptionDetails.tenant_id,
      this.clientId,
      this.subscriptionDetails.id
      , selectedChannels);

    service.subscribe({
      next: (data: any) => {
        this.translate
          .get('SUBSCRIPTIONS.MSG.SUBSCRIPTION_SEND_MANAGELINK')
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });

        this.emailSelected = false;
        this.smsSelected = false;
        this.whatsappSelected = false;
        this.sendLinkCollectDues = false;

      },
      error: (error: AppErrors) => {
        this.toastMessageService.showError(error);
      },
    });

  }

  getTrackMode() {
    let modeText:String="";
    if (this.trackMode ==  TrackMode.ClientPurchasePortal || this.trackMode.toString() ==  TrackMode[TrackMode.ClientPurchasePortal]) {
      this.translate
      .get('SUBSCRIPTIONS.TRACK_MODE_PP')
      .subscribe((translations: any) => {
        modeText = translations;
      });
    } else if (this.trackMode == TrackMode.ClientMobileApp || this.trackMode.toString() ==  TrackMode[TrackMode.ClientMobileApp]) {
      this.translate
      .get('SUBSCRIPTIONS.TRACK_MODE_APP')
      .subscribe((translations: any) => {
        modeText = translations;
      });
    } else {
      modeText ='';
    }
    return modeText;
  }

}